import { render } from "./form-textarea.vue?vue&type=template&id=3ef22e83&scoped=true"
import script from "./form-textarea.vue?vue&type=script&lang=js"
export * from "./form-textarea.vue?vue&type=script&lang=js"

import "./form-textarea.vue?vue&type=style&index=0&id=3ef22e83&scoped=true&lang=css"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef22e83"]])

export default __exports__